(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["av-announcement"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('av-announcements')) {
  customElements.define('av-announcements', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.av-announcement-slide')];
      this.index = 0;
      this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.events = new AbortController();
      const options = {signal:this.events.signal};
      this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => {this.show(this.index + Number(button.dataset.direction));this.start();}, options));
      this.pauseButton = this.querySelector('.av-announcement-pause');
      this.pauseButton.setAttribute('aria-pressed', String(this.paused));
      this.pauseButton.addEventListener('click', () => {this.paused = !this.paused;this.pauseButton.setAttribute('aria-pressed',String(this.paused));this.start();}, options);
      this.addEventListener('mouseenter',()=>{this.hovering=true;this.start();},options);
      this.addEventListener('mouseleave',()=>{this.hovering=false;this.start();},options);
      this.addEventListener('focusin',()=>this.start(),options);
      this.addEventListener('focusout',()=>queueMicrotask(()=>this.start()),options);
      document.addEventListener('visibilitychange',()=>this.start(),options);
      this.checkDeadline();
      this.show(0);
      this.querySelectorAll('button').forEach(button=>button.hidden=this.slides.length<2);
      this.start();
      if (this.querySelector('[data-sale-message]')) this.expiryTimer = setInterval(()=>this.checkDeadline(),1000);
    }
    checkDeadline() {
      const deadline = Date.parse(this.dataset.deadline);
      if ((!Number.isFinite(deadline) || Date.now() >= deadline) && this.slides.length > 1) {
        this.querySelector('[data-sale-message]').remove();
        this.slides = [...this.querySelectorAll('.av-announcement-slide')];
        this.show(0);
        this.querySelectorAll('button').forEach(button=>button.hidden=true);
        clearInterval(this.timer);
      }
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide,i)=>{slide.classList.toggle('is-active',i===this.index);slide.setAttribute('aria-hidden',String(i!==this.index));});
    }
    start() {
      clearInterval(this.timer);
      if (!this.paused && !this.hovering && !this.contains(document.activeElement) && !document.hidden && this.slides.length>1) this.timer=setInterval(()=>this.show(this.index+1),4000);
    }
    disconnectedCallback(){clearInterval(this.timer);clearInterval(this.expiryTimer);this.events.abort();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["av-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('keydown',event=>{if(event.key==='Escape'){document.querySelectorAll('.av-nav-dropdown[open],.av-menu[open],.av-search[open]').forEach(el=>{el.open=false;el.querySelector('summary').focus()})}});
document.addEventListener('click',event=>{document.querySelectorAll('.av-nav-dropdown[open],.av-menu[open],.av-search[open]').forEach(el=>{if(!el.contains(event.target)||event.target.closest('.av-menu-panel a,.av-nav-dropdown a'))el.open=false})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["av-product"] && !Shopify.designMode) return;
  try {
    

(() => {
  const sizeRank = value => {
    const key = value.trim().toUpperCase().replace(/\s+/g, '');
    const order = {XXS:0,XS:1,S:2,M:3,L:4,XL:5,XXL:6,'2XL':6,XXXL:7,'3XL':7,XXXXL:8,'4XL':8};
    if (Object.hasOwn(order,key)) return order[key];
    const extended = key.match(/^(\d+)XL$/);
    if (extended) return Number(extended[1])+4;
    return 100;
  };
  const init = root => {
    if (root.dataset.avOptionsReady) return;
    const select = root.querySelector('[data-av-variant]');
    const picker = root.querySelector('[data-av-options]');
    if (!select || !picker) return;
    const records = [...select.options].map(option => ({option,values:JSON.parse(option.dataset.optionValues)}));
    const groups = [...picker.querySelectorAll('[data-option-index]')];
    const colour = groups.find(group => group.dataset.optionKind === 'colour');
    const colourIndex = colour ? Number(colour.dataset.optionIndex) : -1;
    groups.sort((a,b) => ({colour:0,size:1,other:2}[a.dataset.optionKind] - {colour:0,size:1,other:2}[b.dataset.optionKind])).forEach(group => picker.append(group));
    for (const group of groups) {
      if (group.dataset.optionKind !== 'size') continue;
      const values = group.querySelector('.av-option-values');
      [...values.children].sort((a,b) => sizeRank(a.dataset.optionValue)-sizeRank(b.dataset.optionValue) || a.dataset.optionValue.localeCompare(b.dataset.optionValue,undefined,{numeric:true})).forEach(button => values.append(button));
    }
    const sync = () => {
      const chosen = records.find(record => record.option.value === select.value);
      if (!chosen) return;
      for (const group of groups) {
        const index = Number(group.dataset.optionIndex);
        group.querySelector('[data-selected-value]').textContent = chosen.values[index];
        for (const button of group.querySelectorAll('[data-option-value]')) {
          const value = button.dataset.optionValue;
          const matches = records.filter(record => record.values[index] === value && (index === colourIndex || record.values.every((entry,i) => i === index || entry === chosen.values[i])));
          button.disabled = matches.length === 0;
          button.classList.toggle('is-sold-out',matches.length > 0 && !matches.some(record => record.option.dataset.available === 'true'));
          button.setAttribute('aria-pressed',String(value === chosen.values[index]));
        }
      }
    };
    picker.addEventListener('click',event => {
      const button = event.target.closest('[data-option-value]');
      if (!button || button.disabled) return;
      const group = button.closest('[data-option-index]');
      const index = Number(group.dataset.optionIndex);
      const current = records.find(record => record.option.value === select.value);
      if (!current) return;
      const wanted = current.values.map((value,i) => i === index ? button.dataset.optionValue : value);
      let chosen = records.find(record => record.values.every((value,i) => value === wanted[i]));
      if (!chosen && index === colourIndex) {
        const candidates = records.filter(record => record.values[index] === wanted[index]);
        const sizeGroup = groups.find(entry => entry.dataset.optionKind === 'size');
        if (sizeGroup) candidates.sort((a,b) => sizeRank(a.values[Number(sizeGroup.dataset.optionIndex)])-sizeRank(b.values[Number(sizeGroup.dataset.optionIndex)]));
        chosen = candidates.find(record => record.option.dataset.available === 'true') || candidates[0];
      }
      if (!chosen) return;
      select.value = chosen.option.value;
      select.dispatchEvent(new Event('change',{bubbles:true}));
    });
    root.addEventListener('change',event => {if(event.target === select) sync();});
    sync();
    root.querySelector('[data-av-variant-fallback]').hidden = true;
    picker.hidden = false;
    root.dataset.avOptionsReady = 'true';
  };
  const initAll = () => document.querySelectorAll('[data-av-product]').forEach(init);
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initAll); else initAll();
  document.addEventListener('shopify:section:load',initAll);
  document.addEventListener('change',event => {
    const select=event.target.closest('[data-av-variant]');
    if(!select)return;
    const root=select.closest('[data-av-product]');
    const option=select.selectedOptions[0];
    if(!option)return;
    const quantity=root.querySelector('[name="quantity"]');
    if(quantity){quantity.min=option.dataset.min||'1';quantity.step=option.dataset.step||'1';if(option.dataset.max)quantity.max=option.dataset.max;else quantity.removeAttribute('max');quantity.value=quantity.min;}
    const stock=root.querySelector('[data-av-low-stock]');
    if(stock){const text=option.dataset.lowStock||'';stock.querySelector('[data-av-low-stock-text]').textContent=text;stock.hidden=!text.trim();}
    const price=root.querySelector('[data-av-price]');
    price.replaceChildren();
    if(option.dataset.compare){const strike=document.createElement('s');strike.textContent=option.dataset.compare;price.append(strike);}
    const selling=document.createElement('span');selling.className='av-selling-price';selling.textContent=option.dataset.price;price.append(selling);
    const salePromo=root.querySelector('[data-av-promo-deadline]');
    if(salePromo) salePromo.hidden=Number(option.dataset.discount||0)<=0 || Date.now()>=Date.parse(salePromo.dataset.avPromoDeadline);
    const badge=root.querySelector('[data-av-discount]');
    if(badge){const percent=Number(option.dataset.discount||0);badge.textContent=root.dataset.save.replace('[percent]',percent);badge.hidden=percent<=0;}
    const add=root.querySelector('[data-av-add]');add.disabled=option.dataset.available!=='true';add.textContent=add.disabled?add.dataset.soldOut:add.dataset.label;
    const media=document.getElementById(option.dataset.media);
    if(media) root.querySelector('[data-av-thumb="'+media.id+'"]')?.click();
    const url=new URL(location.href);url.searchParams.set('variant',select.value);history.replaceState({},'',url);
  });
})();

(() => {
 const init = root => {
  if(root.dataset.avpReady) return;
  root.dataset.avpReady='true';
  const gallery=root.querySelector('[data-av-gallery]');
  const panels=[...gallery.children];
  const thumbs=root.querySelector('[data-av-thumbs]');
  const show=id=>{panels.forEach(p=>{p.hidden=p.id!==id;if(p.hidden)p.querySelectorAll('video').forEach(v=>v.pause());});thumbs?.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.avThumb===id)));};
  show(panels.find(p=>p.dataset.mediaActive==='true')?.id||panels[0]?.id);
  if(thumbs){thumbs.hidden=false;thumbs.addEventListener('click',e=>{const b=e.target.closest('[data-av-thumb]');if(b)show(b.dataset.avThumb);});}
  const form=root.querySelector('form[action*="/cart/add"]');
  const select=root.querySelector('[data-av-variant]');
  const bundle=root.querySelector('[data-av-bundle]');
  if(!form||!select) return;
  const quantity=form.querySelector('[name="quantity"]');
  const container=root.querySelector('[data-bundle-items]');
  let count=1;
  if(bundle){bundle.hidden=false;bundle.addEventListener('click',e=>{
    const button=e.target.closest('[data-bundle-quantity]');if(!button)return;
    count=button.getAttribute('aria-pressed')==='true'?1:Number(button.dataset.bundleQuantity);
    bundle.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.bundleQuantity)===count)));
    quantity.closest('.avp-quantity').hidden=count>1;
    container.replaceChildren();
    for(let i=0;i<count&&count>1;i++){
      const label=document.createElement('label');label.textContent=container.dataset.itemLabel.replace('[number]',i+1);
      const choices=select.cloneNode(true);choices.removeAttribute('id');choices.removeAttribute('name');choices.removeAttribute('data-av-variant');
      [...choices.options].forEach(o=>o.disabled=o.dataset.available!=='true');
      choices.value=select.value;
      label.append(choices);container.append(label);
    }
  });}
  form.addEventListener('submit',async e=>{
   if(count===1)return;
   e.preventDefault();
   const button=root.querySelector('[data-av-add]');const error=root.querySelector('[data-cart-error]');
   const items=[...container.querySelectorAll('select')].map(s=>({id:s.value,quantity:1}));
   if(items.some(i=>!i.id))return;
   button.disabled=true;button.setAttribute('aria-busy','true');error.hidden=true;
   try{const path=form.action.replace(/\/add(?:\?.*)?$/,'/add.js');const response=await fetch(path,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});const data=await response.json();if(!response.ok)throw new Error(data.description||data.message);location.assign(form.action.replace(/\/add(?:\?.*)?$/,''));}
   catch(err){error.textContent=err.message;error.hidden=false;button.disabled=false;button.removeAttribute('aria-busy');}
  });
 };
 const all=()=>document.querySelectorAll('.avp').forEach(init);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all);else all();
 document.addEventListener('shopify:section:load',all);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
